import React from "react";
import { withSafeRotateSvg } from "../../hoc/withSafeRotateSvg";

const FuzzyBorder: React.FC<DogsTrust.CurveProps> = ({
	fill = "#FFC800",
	className,
	style,
}) => {
	return (
		<svg
			className={className}
			style={{ ...style, maxHeight: "100px", width: "100%" }}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 1920 300"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="none"
		>
			<path
				d="M291.743 44.76c-6.98 10.258-15.82 18.834-26.864 26.824-17.476 12.63-54.613 34.305-71.004 40.014a7864.729 7864.729 0 0045.656 9.66c94.95 18.496 185.37 31.245 274.581 38.329 267.627 21.243 722.317-5.755 845.814-27.745-13.708 33.927-39.084 65.32-84.577 99.723 144.2-17.987 428.162-103.753 465.15-131.015-7.172 47.167-24.2 75.594-28.206 81.763-.28.43.24.91.776.726 14.43-4.86 121.63-41.307 206.91-80.057.027-.012.027 64.329 0 193.023H.037C-.011 98.66-.013-.008.033 0 .11.013 125.848 20.68 190.347 30.21c39.572 6.032 73.472 10.91 101.396 14.55z"
				fill={fill}
				fillRule="evenodd"
			/>
		</svg>
	);
};

export default withSafeRotateSvg<DogsTrust.CurveProps>(FuzzyBorder);
